<main>
    <div
        style="
            height: calc(100% - 64px);
            box-shadow: 0 3px 8px rgb(20 20 20 / 18%);
            border-radius: 5px 0 0 5px;
            overflow: auto;
            background: #fff;
            margin-bottom: 20px;
        "
    >
        <div class="content" style="padding: 20px">
            <div style="display: flex; gap: 10px">
                <div>
                    <label for="" class="label-input">Password</label>
                    <div class="input-group">
                        <input
                            trim
                            class="input-c"
                            matInput
                            (keydown.enter)="checkPass()"
                            placeholder="Password"
                            [(ngModel)]="pwd"
                        />
                    </div>
                </div>
                <!-- <div class="input-group">
                    <input
                        class="input-t"
                        type="text"
                        (keydown.enter)="checkPass()"
                        [(ngModel)]="pwd"
                        [type]="showPassC1 ? 'text' : 'password'"
                    />
                    <div class="pass-addon" (click)="showPassC1 = !showPassC1">
                        <img
                            *ngIf="!showPassC1"
                            src="../../assets/icons/eye-open.svg"
                            style="width: 22px; height: 22px"
                        />
                        <img
                            *ngIf="showPassC1"
                            src="../../assets/icons/eye-close.svg"
                            style="width: 22px; height: 22px"
                        />
                    </div>
                </div> -->
                <div style="display: flex; align-items: flex-end">
                    <button class="save-pass" (click)="checkPass()">
                        Check
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- -->
    <div
        *ngIf="checkedPwd"
        style="
            height: calc(100% - 64px);
            box-shadow: 0 3px 8px rgb(20 20 20 / 18%);
            border-radius: 5px 0 0 5px;
            overflow: auto;
            background: #fff;
        "
    >
        <div class="content" style="padding: 20px">
            <div
                style="display: flex; justify-content: space-between"
                class="head"
            >
                <div class="cl">Change logs</div>
                <div>
                    <button class="save-pass" (click)="checkedPwd = false">
                        Hide
                    </button>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.1</span>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        1. เพิ่ม Function Copy รายการรายรับรายจ่าย
                    </div>
                    <div class="data-detail">
                        2. ปรับปรุง Layout หน้า รายรับรายจ่าย
                    </div>
                    <div class="data-detail">
                        3. ปรับปรุง Layout หน้า Dashboard
                    </div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.2</span>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">1. แก้บัคเพิ่ม Default รูป</div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.4</span>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        1. แก้บัครายรับรายจ่าย Copy ข้อมูลแล้วกลายเป็น Edit
                        ใบเก่า
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        2. เพิ่ม display page หน้า receive order
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        3. หน้า Issue เพิ่ม owner name มาแสดง ปรับ lv จาก branch
                        เป็น all
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        4. เพิ่ม filter search หน้า Check stock
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        5. ปรับใบกำกับภาษีเป็น fix branch code 0001
                    </div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.5</span>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">1. แก้บัคเรื่องการตัดสต๊อก</div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.6</span
                    ><span style="margin-left: 7px; color: gray"
                        >(Deploy date: 02/07/2024)</span
                    >
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        1. เพิ่ม export excel ในหน้า Check stock
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        2. เพิ่ม Market price ในหน้า Check stock
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">3. แก้บัคเรื่องการตัดสต๊อก</div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.7</span
                    ><span style="margin-left: 7px; color: gray"
                        >(Deploy date: 02/08/2024)</span
                    >
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        1. แก้ไขหน้าจอ โปรโมชั่น ส่วนลด เลือก customize
                        สาขาของโปรโมชั่นแล้วชื่อสาขาไม่แสดง
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        2. เพิ่ม food type = Additional มาแสดงในหน้าจอ sale
                        volume report
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        3. ปิดปุ่มสร้าง ในหน้าจอ transfer ของ User company & sub
                        company
                    </div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.8</span
                    ><span style="margin-left: 7px; color: gray"
                        >(Deploy date: 15/08/2024)</span
                    >
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">1. แก้ไขบัค</div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">2. เพิ่ม Additional group</div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        3. เพิ่ม Material Category ใน Inventory
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        4. ปรับ Detail หน้า Material ให้แสดง Category
                    </div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.9</span
                    ><span style="margin-left: 7px; color: gray"
                        >(Deploy date: 20/09/2024)</span
                    >
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">1. เพิ่ม remark ใน Purchase</div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        2. เพิ่มรายละเอียด Vat และ Withholding Tax ในรายละเอียด
                        Income/Expense
                    </div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.15</span
                    ><span style="margin-left: 7px; color: gray"
                        >(Deploy date: 28/01/2025)</span
                    >
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">1. ปรับหน้าจอ Dashboard ใหม่</div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        2. ปรับ API การดึงข้อมูลเมนู Rev Dashboard
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        3. ปรับ API การดึงข้อมูลเมนู Membership
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        4. แก้ไข field ราคาในเมนู Food ให้สามารถระบุราคาเป็น 0
                        บาทได้
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        5. Report Stock movement เพิ่ม filter by Action และ ปรับ
                        export excel เป็น export all data ตาม filter
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        6. แก้เรื่องเวลาเปิดปิดร้าน เมนู Branch info
                    </div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.18</span
                    ><span style="margin-left: 7px; color: gray"
                        >(Deploy date: 04/02/2025)</span
                    >
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        1. เพิ่มข้อมูลใน Promotion report
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">2. แก้ไขบัคหน้า Sale volume</div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.22</span
                    ><span style="margin-left: 7px; color: gray"
                        >(Deploy date: 24/04/2025)</span
                    >
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        1. Inventory report แก้ไขรายงาน
                        และการคำนวนประมาณมูลค่าคงคลัง
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        2. เพิ่ม Config Sorting หมวดหมู่อาหาร ที่จะแสดงใน POS
                        และ Mobile
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        3. แก้ไขการแสดงรายวัตถุดิบ
                        ให้แสดงทุกรายการที่มีจำนวนคงเหลือในคลัง เพื่อให้ทำ
                        การแปรรูป ได้
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        4. แก้ไขบัคปุ่มลบ ที่เมนู การแปรรูป
                    </div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.25 - v 1.3.26</span
                    ><span style="margin-left: 7px; color: gray"
                        >(Deploy date: 04/07/2025)</span
                    >
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">1. แก้บัคหน้า Rev Dashboard</div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        2. เพิ่ม Customize ใน foodType เครื่องดื่ม
                    </div>
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        3. หน้าจอสร้าง Promotion แสดงเฉพาะรายการอาหาร สถานะ
                        Active เท่านั้น และเพิ่มปุ่ม search
                    </div>
                </div>
            </div>
            <div>
                <div style="margin-top: 20px; margin-bottom: 15px">
                    <span class="v">v 1.3.32</span
                    ><span style="margin-left: 7px; color: gray"
                        >(Deploy date: 14/05/2026)</span
                    >
                </div>
                <div style="margin-top: 8px">
                    <div class="data-detail">
                        1. แก้บัคหน้า Income/Expense Detail
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
